"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
var objectInspect = require("object-inspect");
/**
 * @hidden
 * This class encapsulates the result of a call to a state handler
 */
var Result = /** @class */ (function () {
    /**
     * Creates a new result
     * @param actions the transition actions
     */
    function Result() {
        var _a;
        var actions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            actions[_i] = arguments[_i];
        }
        /**
         * @hidden
         * @type {"none"}
         */
        this.type = 'none';
        /**
         * @hidden
         * The list of actions for this state
         */
        this.actions = [];
        (_a = this.actions).push.apply(_a, actions);
    }
    Object.defineProperty(Result.prototype, "actionsString", {
        /**
         * @hidden
         * @return {string}
         */
        get: function () {
            return this.actions.map(function (x) { return x.toString(); }).join(", ");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Result.prototype, "dataString", {
        /**
         * @hidden
         * @return {string}
         */
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Result.prototype.toString = function () {
        return [this.type, objectInspect({ actions: this.actions })].join(' ');
    };
    return Result;
}());
exports.default = Result;
//# sourceMappingURL=Result.js.map